import { useResetOnClose } from "@/lib/hooks/useResetOnClose"
import React, { FC, Dispatch, SetStateAction } from "react"
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline"
import { Table } from "@/components/general/Table"
import { RateEngineWeightType } from "@/lib/types"
import { Modal } from "@/components/general/Modal"
import { useForm } from "react-hook-form"

type Props = {
  popup: boolean
  setPopup: Dispatch<SetStateAction<boolean>>
  listingData: { RateEngine: RateEngineWeightType[] }
  header: {
    name: string
    width: string
  }[]
  handleFormUpdate: (form: RateEngineWeightType) => void
}

export const RateEngineWeight: FC<Props> = (props) => {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm<RateEngineWeightType>()

  const onSubmit = (data: RateEngineWeightType) => {
    props.handleFormUpdate(data)
  }

  const populateData = (e: RateEngineWeightType) => {
    setValue("id", e.id)
    setValue("datWeightPercentage", e.datWeightPercentage)
    setValue("btsWeightPercentage", e.btsWeightPercentage)
    props.setPopup(true)
  }

  useResetOnClose(props.popup, () => {
    reset({
      datWeightPercentage: undefined,
      btsWeightPercentage: undefined,
      id: "",
    })
  })

  return (
    <>
      <Modal
        open={props.popup}
        close={() => props.setPopup(false)}
        width="small"
        title="Update Rate Engine Weight"
      >
        <div className="flex flex-col gap-3">
          <div className="grid grid-cols-2 gap-2">
            <fieldset>
              <label className="text-xs dark:text-primary-8 text-light-1">
                Dat Weight Percentage
              </label>
              <input
                className={
                  (errors.datWeightPercentage
                    ? "border-red-400"
                    : "dark:border-secondary-2") +
                  " w-full text-sm p-2  dark:bg-transparent bg-white text-light-2 outline-none dark:text-white border-2 rounded placeholder:text-xs"
                }
                type="number"
                {...register("datWeightPercentage", { required: true })}
              />
            </fieldset>
            <fieldset>
              <label className="text-xs dark:text-primary-8 text-light-1">
                Bts Weight Percentage
              </label>
              <input
                className={
                  (errors.btsWeightPercentage
                    ? "border-red-400"
                    : "dark:border-secondary-2") +
                  " w-full text-sm p-2  dark:bg-transparent bg-white text-light-2 outline-none dark:text-white border-2 rounded placeholder:text-xs"
                }
                type="number"
                {...register("btsWeightPercentage", { required: true })}
              />
            </fieldset>
          </div>
          <button
            onClick={handleSubmit(onSubmit)}
            className=" bg-primary-8 px-4 py-2 rounded font-medium w-full dark:text-secondary-1 text-primary-1"
            type="button"
          >
            Submit
          </button>
        </div>
      </Modal>
      <div className="m-4">
        <Table
          header={props.header}
          headerAlign="text-left"
          lastheadingAlign="text-right"
        >
          {props.listingData.RateEngine.map((e, i) => (
            <tr key={i} className="text-left">
              <td className={"whitespace-nowrap p-4 w-72"}>
                {e.datWeightPercentage}
              </td>
              <td className={"whitespace-nowrap p-4 w-72"}>
                {e.btsWeightPercentage}
              </td>
              <td className={"whitespace-nowrap p-4 w-24"}>
                <div className="flex justify-end gap-2">
                  <PencilSquareIcon
                    className="w-4 h-4 text-accent cursor-pointer"
                    onClick={() => populateData(e)}
                  />
                </div>
              </td>
            </tr>
          ))}
        </Table>
      </div>
    </>
  )
}
